import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction } from "mobx";
import { routeLocationLicenseActivationDelete } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { __ } from "../utils/i18n.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
const CONNECT_LOST_MILLISECONDS = 3 * 24 * 60 * 60 * 1000;
class LicenseActivation {
    get host() {
        var _this_data_client_properties_filter_, _this_data;
        return (_this_data = this.data) == null ? void 0 : (_this_data_client_properties_filter_ = _this_data.client.properties.filter((param)=>{
            let { key } = param;
            return key === "hostname";
        })[0]) == null ? void 0 : _this_data_client_properties_filter_.value;
    }
    get pluginVersion() {
        var _this_data_properties_filter_, _this_data;
        return ((_this_data = this.data) == null ? void 0 : (_this_data_properties_filter_ = _this_data.properties.filter((param)=>{
            let { key } = param;
            return key === "pluginVersion";
        })[0]) == null ? void 0 : _this_data_properties_filter_.value) || __("Unknown");
    }
    get lastSeen() {
        var _this_data_client_properties_filter_, _this_data;
        const lastSeen = (_this_data = this.data) == null ? void 0 : (_this_data_client_properties_filter_ = _this_data.client.properties.filter((param)=>{
            let { key } = param;
            return key === "lastSeen";
        })[0]) == null ? void 0 : _this_data_client_properties_filter_.value;
        return lastSeen ? new Date(lastSeen) : undefined;
    }
    get isConnectionLost() {
        const now = Date.now();
        const { lastSeen } = this;
        return lastSeen ? now - lastSeen.getTime() > CONNECT_LOST_MILLISECONDS : false;
    }
    get session() {
        return this.store.store;
    }
    constructor(data, store){
        this.busy = false;
        this.delete = flow(function*() {
            this.busy = true;
            yield this.session.probablyRenewJwt();
            try {
                const { data: { license: { licenseKey }, client: { uuid } } } = this;
                yield realCommerceRequest({
                    location: routeLocationLicenseActivationDelete,
                    request: {
                        licenseActivation: {
                            license: {
                                licenseKey
                            },
                            client: {
                                uuid
                            }
                        }
                    },
                    settings: {
                        headers: this.session.authorizationHeader
                    }
                });
                yield this.session.fetchLicenses();
                this.store.fetchActivations();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], LicenseActivation.prototype, "data", void 0);
_ts_decorate([
    observable
], LicenseActivation.prototype, "busy", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], LicenseActivation.prototype, "host", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], LicenseActivation.prototype, "pluginVersion", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], LicenseActivation.prototype, "lastSeen", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], LicenseActivation.prototype, "isConnectionLost", null);
export { LicenseActivation };
